import Affiliate, {
  getServerSideProps as hgetServerSideProps,
} from '@pages/myapp/affiliate';
import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = hgetServerSideProps;

export default Affiliate;
